import { render, staticRenderFns } from "./tabCategory.vue?vue&type=template&id=43b38af0&scoped=true&"
import script from "./tabCategory.vue?vue&type=script&lang=js&"
export * from "./tabCategory.vue?vue&type=script&lang=js&"
import style0 from "./tabCategory.vue?vue&type=style&index=0&id=43b38af0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b38af0",
  null
  
)

export default component.exports